import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function GeneralReportTenantManage ( props ) {

    return <BasicCrudScreenType id="GeneralReportTenantManage" noExcel table="GeneralReportTenant" view="VwGeneralReportTenant" />

}

export default GeneralReportTenantManage;